import { useMutation, useQueryClient } from '@tanstack/react-query';
import { myPageService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { bridge } from 'shared/src/utils';
import type { PatchMemberInfoRequest } from 'shared/src/api/myPageService/patchMemberInfo/types';

export const usePatchMemberInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PatchMemberInfoRequest) =>
      myPageService.patchMemberInfo(data),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: queryKey.myInfo });
      await bridge.updateMemberMe(JSON.stringify({ refetch: false }));
    },
  });
};
